import React, { useEffect, useState } from "react";
import { auth, db } from "../../Admin/Config/Config";
import Loading from "../../assets/Loading/Loading";
import { useLoginPopup } from "../../Auth/LoginContext";
import { useNavigate } from "react-router-dom";
import Emptycart from "./Emptycart";

import './css/Product.css';
import { useCart } from "./CartContext";
import { useQuote } from "../Quote/QuoteContext";
import { doc, getDoc } from "firebase/firestore";

export default function Cart() {
  // =============================== STATE MANAGEMENT =============================== //
  const { cart, updateQuantity, removeFromCart, emptyCart } = useCart(); // <-- Use useCart
  const [quantityLoading, setQuantityLoading] = useState(false);
  const [quantityId, setQuantityId] = useState("");
  const { openPopup } = useLoginPopup();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [totalAmount, setTotalAmount] = useState(0);
  const [priceFlag, setPriceFlag] = useState(false);
  const { openQuote } = useQuote();

  // =============================== CART FETCHING =============================== //
  useEffect(() => {
    if (cart) {
      setLoading(false);
    }
  }, [cart, emptyCart]);



  // =============================== CART FETCHING =============================== //
  // useEffect(() => {
  //   if (auth.currentUser) {
  //     const fetch = async () => {
  //      await fetchCart(auth.currentUser.uid);
  //     };
  //     fetch();
  //   } else {
  //       const fetch = async () => {
  //           await fetchCart("");
  //       };
  //     fetch();
  //     //openPopup();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
    if (cart) {
      if (cart.length === 0 && emptyCart === true) {
        setLoading(false);
      } else if (cart.length > 0 && emptyCart === false) {
        setLoading(false);
      }
    }
  }, [cart, emptyCart])

  // =============================== QUANTITY HANDLER =============================== //
  // Update product quantity in cart
  const quantityChangeHandler = async (id, value) => {
    // removePromo() // Remove any applied promo when quantity changes
    const result = await updateQuantity(id, value);
    if (result) {
      setQuantityLoading(false);
      setQuantityId("");
    } else {
      setQuantityId("");
      setQuantityLoading(false);
    }
  };

  // Remove item from cart completely
  const handleRemove = async (id) => {
    // removePromo() // Remove any applied promo when item is removed
    setQuantityLoading(true);
    setQuantityId(id);
    const result = await removeFromCart(id);
    if (result) {
      setQuantityId("");
      setQuantityLoading(false);
    } else {
      setQuantityId("");
      setQuantityLoading(false);
    }
  };

  // Tax calculation state
  const [taxAmount, settaxAmount] = useState(0);
  const [noPrizeFlag, setNoPrizeFlag] = useState(false);
  // Calculate total amount and tax when cart changes
  useEffect(() => {
    if (cart) {
      let total = 0;
      let taxTotal = 0;
      cart.forEach((item) => {
        if (item.offer_price === 0 || item.offer_price === null) {
          setNoPrizeFlag(true);
        }
        total += item.offer_price * item.cart_quantity;
        if (item.tax_applicable === true) {
          taxTotal += item.offer_price * item.cart_quantity;
        }
      });
      const tax = ((taxTotal / 100) * 13).toFixed(2); // 13% HST tax
      settaxAmount(parseFloat(tax));
      setTotalAmount(parseFloat(total.toFixed(2)));
      setPriceFlag(parseFloat(total.toFixed(2)) > 0 ? false : true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cart]);

  // Increment quantity by 1
  const increment = (id, qty) => {
    console.log(id)
    setQuantityLoading(true);
    setQuantityId(id);
    quantityChangeHandler(id, parseInt(qty) + 1);
  };

  const decrement = async (id, qty) => {
    setQuantityLoading(true);
    setQuantityId(id);
    if (qty > 0) {
      quantityChangeHandler(id, parseInt(qty) - 1);
    } else {
      const result = await removeFromCart(
        auth.currentUser ? auth.currentUser.uid : '',
        id
      );
      if (result) {
        setQuantityLoading(false);
        setQuantityId("");
      } else {
        setQuantityLoading(false);
        setQuantityId("");
      }
    }
  };


  const handleClick = () => {
    if (auth.currentUser) {
      navigate("/billing-address",
      );
    } else {
      openPopup();
    }
  };
  const handleGetQuote = () => {
    const updatedCart = cart.filter((item) => !item.priceFlag);
    openQuote({ cart: true, products: updatedCart });
  };

  // =============================== MAIN RENDER =============================== //
  const [deliveryCharge, setDeliveryCharge] = useState(0);
  useEffect(() => {
    const calculateDeliveyCharge = async (total) => {
      const configDoc = await getDoc(doc(db, "configurations", "delivery_charges"));
      const chargesData = configDoc.data();
      if (chargesData && chargesData.charges) {
        let charge = 0;
        for (const chargeRule of chargesData.charges) {
          if (
            total >= chargeRule.min_amount &&
            total <= chargeRule.max_amount
          ) {
            charge = chargeRule.delivery_charge;
            break;
          }
        }
        return charge;
      }
      return 0;
    };

    const getCharge = async () => {
      const total = parseFloat(totalAmount || 0);
      const charge = await calculateDeliveyCharge(total);
      setDeliveryCharge(charge);
    };
    if (totalAmount) {
      getCharge();
    }
  }, [totalAmount, taxAmount]);
  return (
    <>
      {loading ? (
        // Show loading spinner while cart data is being fetched
        <Loading />
      ) : (
        <>
          {!emptyCart ? (
            // Main cart page layout with professional red/white/gray design
            <div className="min-h-screen bg-gray-50 py-8 ">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20">
                {/* =============================== HEADER SECTION =============================== */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-8">
                  <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
                    <div>
                      <h1 className="text-2xl font-bold text-gray-900">
                        Shopping Cart
                      </h1>
                      <p className="text-gray-600 mt-1">
                        Review your items and proceed to checkout
                      </p>
                    </div>
                    {cart && cart.length > 0 && (
                      <div className="mt-4 sm:mt-0">
                        {/* Item count badge with red accent */}
                        <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-red-100 text-red-800">
                          {cart.length} {cart.length === 1 ? "Item" : "Items"}
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                {/* =============================== MAIN CONTENT GRID =============================== */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                  {/* =============================== CART ITEMS SECTION =============================== */}
                  <div className="lg:col-span-2">
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                      {cart &&
                        cart.map((item, index) => (
                          <div
                            key={item.id}
                            className={`${index !== 0 ? "border-t border-gray-200" : ""
                              }`}
                          >
                            {/* =============================== OUT OF STOCK BADGE =============================== */}
                            {item.stock < 1 && (
                              <div className="relative">
                                <div className="absolute top-4 left-4 z-10">
                                  <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800 border border-red-200">
                                    OUT OF STOCK
                                  </span>
                                </div>
                              </div>
                            )}

                            {/* =============================== PRODUCT ITEM CARD =============================== */}
                            <div
                              className={`relative p-6 ${(quantityLoading === true &&
                                item.id === quantityId) ||
                                item.stock < 1
                                ? "opacity-50"
                                : ""
                                }`}
                            >
                              {/* Loading overlay for quantity updates */}
                              {((quantityLoading === true &&
                                item.id === quantityId) ||
                                item.stock < 1) && (
                                  <div className="absolute inset-0 bg-white bg-opacity-75 pointer-events-none z-10 rounded-lg"></div>
                                )}

                              <div className="flex flex-col md:flex-row gap-6">
                                {/* =============================== PRODUCT IMAGE =============================== */}
                                <div className="flex-shrink-0">
                                  <div className="w-24 h-24 md:w-32 md:h-32 bg-gray-100 rounded-lg overflow-hidden">
                                    <img
                                      src={item.thumb_url}
                                      alt={item.product_name}
                                      className="w-full h-full object-cover"
                                    />
                                  </div>
                                </div>

                                {/* =============================== PRODUCT DETAILS =============================== */}
                                <div className="flex-1 min-w-0">
                                  <div className="flex justify-between items-start">
                                    <div className="flex-1">
                                      {/* Product name and tax indicator */}
                                      <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                        {item.product_name}
                                        {item.tax_applicable === true && (
                                          <span className="ml-2 inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                                            HST Applicable
                                          </span>
                                        )}
                                      </h3>
                                      <p className="text-sm text-gray-600 mb-3">
                                        {item.brand}
                                      </p>

                                      {/* =============================== QUANTITY CONTROLS =============================== */}
                                      <div className="flex items-center justify-between">
                                        <div className="flex items-center space-x-3">
                                          <div className="flex items-center border border-gray-300 rounded-lg bg-white">
                                            {/* Decrement button */}
                                            <button
                                              disabled={
                                                (quantityLoading &&
                                                  item.id === quantityId) ||
                                                item.stock < 1
                                              }
                                              onClick={() =>
                                                decrement(
                                                  item.id,
                                                  item.cart_quantity
                                                )
                                              }
                                              className="w-10 h-10 flex items-center justify-center text-gray-600 hover:text-red-600 hover:bg-gray-50 rounded-l-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                            >
                                              <svg
                                                className="w-4 h-4"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                              >
                                                <path
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                  strokeWidth="2"
                                                  d="M20 12H4"
                                                ></path>
                                              </svg>
                                            </button>

                                            {/* Quantity display */}
                                            <span className="w-12 text-center text-gray-900 font-medium">
                                              {item.cart_quantity}
                                            </span>

                                            {/* Increment button */}
                                            <button
                                              disabled={
                                                (quantityLoading &&
                                                  item.id === quantityId) ||
                                                item.stock < 1
                                              }
                                              onClick={() =>
                                                increment(
                                                  item.id,
                                                  item.cart_quantity
                                                )
                                              }
                                              className="w-10 h-10 flex items-center justify-center text-gray-600 hover:text-red-600 hover:bg-gray-50 rounded-r-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                            >
                                              <svg
                                                className="w-4 h-4"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                              >
                                                <path
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                  strokeWidth="2"
                                                  d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                                ></path>
                                              </svg>
                                            </button>
                                          </div>
                                        </div>

                                        {/* =============================== PRICE DISPLAY =============================== */}
                                        <div className="text-right">
                                          <p className="text-xl font-bold text-gray-900">
                                            $
                                            {(
                                              parseFloat(item.offer_price) *
                                              parseInt(item.cart_quantity)
                                            ).toFixed(2)}
                                          </p>
                                          <p className="text-sm text-gray-500">
                                            ${item.offer_price} each
                                          </p>
                                        </div>
                                      </div>
                                    </div>

                                    {/* =============================== REMOVE BUTTON =============================== */}
                                    <button
                                      onClick={() => handleRemove(item.id)}
                                      className="ml-4 p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-full transition-colors"
                                      title="Remove item"
                                    >
                                      <svg
                                        className="w-5 h-5"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth="2"
                                          d="M6 18L18 6M6 6l12 12"
                                        ></path>
                                      </svg>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>

                    {/* =============================== CONTINUE SHOPPING LINK =============================== */}
                    <div className="mt-6">
                      <a
                        href="/"
                        className="inline-flex items-center text-red-600 hover:text-red-800 font-medium transition-colors"
                      >
                        <svg
                          className="w-4 h-4 mr-2"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M10 19l-7-7m0 0l7-7m-7 7h18"
                          ></path>
                        </svg>
                        Continue Shopping
                      </a>
                    </div>
                  </div>

                  {/* =============================== ORDER SUMMARY SECTION =============================== */}
                  {cart && (
                    <div className="lg:col-span-1">
                      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 sticky top-8">
                        <h2 className="text-xl font-bold text-gray-900 mb-6">
                          Order Summary
                        </h2>

                        {/* =============================== ITEMS COUNT =============================== */}
                        <div className="flex justify-between items-center py-3 border-b border-gray-200">
                          <span className="text-gray-600">
                            Items ({cart.length})
                          </span>
                          <span className="font-semibold text-gray-900">
                            ${priceFlag ? "N/A" : totalAmount}
                          </span>
                        </div>

                        {/* =============================== PRICE BREAKDOWN =============================== */}
                        <div className="mt-6 space-y-3">
                          {/* Subtotal */}
                          <div className="flex justify-between text-sm">
                            <span className="text-gray-600">Subtotal</span>
                            <span className="font-medium text-gray-900">
                              ${priceFlag ? "N/A" : totalAmount}
                            </span>
                          </div>

                          {/* HST Tax (if applicable) */}
                          {taxAmount > 0 && (
                            <div className="flex justify-between text-sm">
                              <span className="text-gray-600">HST</span>
                              <span className="font-medium text-gray-900">
                                ${taxAmount}
                              </span>
                            </div>
                          )}
                          {/* Delivery Charge (if applicable) */}
                          {deliveryCharge > 0 && (
                            <>
                              <div className="flex justify-between text-sm">
                                <span className="text-gray-600">Delivery Charge</span>
                                <span className="font-medium text-gray-900">
                                  ${deliveryCharge}
                                </span>
                              </div>
                              <div className="mt-3 bg-blue-50 border border-blue-100 rounded-lg p-3 flex items-start gap-3">
                                <svg
                                  className="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <p className="text-sm text-blue-700 font-medium leading-tight">
                                  Enjoy <span className="font-bold underline decoration-blue-300 decoration-2 underline-offset-2">Free Delivery</span> on orders above <span className="text-red-600 font-bold">$250</span>! Add more items to your cart to save on shipping.
                                </p>
                              </div>
                            </>
                          )}

                          {/* Total Amount */}
                          <div className="border-t border-gray-200 pt-3">
                            <div className="flex justify-between">
                              <span className="text-lg font-bold text-gray-900">
                                Total
                              </span>
                              <span className="text-lg font-bold text-gray-900">

                                {priceFlag ? "N/A" : parseFloat(parseFloat(totalAmount) + parseFloat(taxAmount) + parseFloat(deliveryCharge)).toFixed(2)}
                              </span>
                            </div>
                          </div>
                        </div>

                        {/* =============================== CHECKOUT BUTTON =============================== */}
                        <div className="mt-6">
                          {!noPrizeFlag ? (
                            <button
                              onClick={handleClick}
                              disabled={cart.some((item) => item.stock < 1)}
                              className={`w-full py-3 px-4 rounded-lg font-semibold text-white transition-colors ${cart.some((item) => item.stock < 1)
                                ? "bg-gray-400 cursor-not-allowed"
                                : "bg-red-600 hover:bg-red-700 shadow-sm"
                                }`}
                            >
                              Proceed to Checkout
                            </button>
                          ) : (
                            <button
                              onClick={handleGetQuote}
                              disabled={cart.some((item) => item.stock < 1)}
                              className={`w-full py-3 px-4 rounded-lg font-semibold text-white transition-colors ${cart.some((item) => item.stock < 1)
                                ? "bg-gray-400 cursor-not-allowed"
                                : "bg-red-600 hover:bg-red-700 shadow-sm"
                                }`}
                            >
                              Get a Quote
                            </button>
                          )}

                          {/* Out of stock warning */}
                          {cart.some((item) => item.stock < 1) && (
                            <p className="text-red-600 text-sm mt-2 text-center">
                              Some items are out of stock
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <Emptycart />
          )}
        </>
      )}
    </>
  );
}